import { MaterialIconName } from '@gorila-shared-ui/components';

export const ZONE_FENCES_TYPES: {
  [key: string]: {
    title: string;
    icon: MaterialIconName;
  };
} = {
  '1': { title: 'De riesgo', icon: 'zone_person_alert' },
};

export const ZONE_FENCE_IDS = Object.keys(ZONE_FENCES_TYPES);

export const ZONE_FENCES = Object.values(ZONE_FENCES_TYPES);
